module.exports = __webpack_public_path__ + "img/malattia.3dd81b49.png";